import React from "react";
import { Modal } from "antd";
import { t } from "i18next";
import moment from "moment";
import { Util } from "common/util";
import {
  InputText,
  Form,
  Button,
  SelectInput,
  NumberInput,
  TimeInput,
  Spin,
} from "common/elements";
import {
  getOne,
  insertNewRecord,
  updateRecordById,
} from "services/overtime_type";

const util = new Util();

export default class FormModal extends React.PureComponent {
  state = {
    isModalVisible: false,
    id: null,
    timeFormat: "hh:mm A",
    loading: false,
    disabled: false,
    loadingFormData: false,
  };

  getTimeFormat = (time, format) => {
    if (!time) {
      return "";
    }
    return moment(time, format);
  };

  showModal = (id) => {
    if (id) {
      this.setState({ loadingFormData: true, isModalVisible: true });
      getOne(id)
        .then((response) => {
          if (response) {
            const formData = response.data;
            this.props.form.setFieldsValue({
              name: formData.name,
              nameKH: formData.nameKH,
              type: formData.type,
              rate: formData.rate,
              startTime: this.getTimeFormat(
                formData.startTime,
                this.state.timeFormat
              ),
              endTime: this.getTimeFormat(
                formData.endTime,
                this.state.timeFormat
              ),
            });
          }
        }).catch(error => {
          if (error.response.status === 403) {
            localStorage.removeItem("ACCESS_TOKEN");
            this.props.navigate("/signin");
          }
        })
        .finally(() => {
          this.setState({
            isModalVisible: true,
            id,
            loadingFormData: false,
          });
        });
    } else {
      this.setState({
        isModalVisible: true,
        id: null,
      });
    }
  };

  handleCancel = () => {
    this.props.form.resetFields();
    this.setState({
      isModalVisible: false,
      disabled: false,
    });
  };

  onFinish = (values) => {
    values["startTime"] = util.formatTimePicker(values.startTime);
    values["endTime"] = util.formatTimePicker(values.endTime);
    this.setState({ loading: true, disabled: true });
    if (this.state.id) {
      updateRecordById(this.state.id, values)
        .then(() => {
          this.setState({
            isModalVisible: false,
          });
          this.props.form.resetFields();
          this.props.onSuccess();
        })
        .finally(() => {
          this.setState({ loading: false, disabled: false });
        });
    } else {
      insertNewRecord(values)
        .then(() => {
          this.setState({
            isModalVisible: false,
          });
          this.props.form.resetFields();
          this.props.onSuccess();
        })
        .finally(() => {
          this.setState({ loading: false, disabled: false });
        });
    }
  };

  onFinishFailed = (errorInfo) => {
    console.log("Failed:", errorInfo);
  };

  render() {
    const {
      isModalVisible,
      timeFormat,
      loading,
      loadingFormData,
      id,
      disabled,
    } = this.state;
    return isModalVisible ? (
      <Modal
        title={id ? t("text_edit_overtime_type") : t("text_new_overtime_type")}
        visible={isModalVisible}
        onCancel={this.handleCancel}
        style={{ top: 20 }}
      >
        <Spin spinning={loadingFormData}>
          <Form
            form={this.props.form}
            onFinish={this.onFinish}
            layout="vertical"
            onFinishFailed={this.onFinishFailed}
            key={id}
          >
            <InputText
              name="name"
              label={t("text_name")}
              placeholder={t("text_overtime_type_name_in_english")}
              requiredMessage={t("text_please_input_name_in_english")}
              isAutoSelect={true}
            />
            <InputText
              name="nameKH"
              label={t("text_name_Kh")}
              isAutoSelect={true}
              requiredMessage={t("text_please_input_name_in_khmer")}
              placeholder={t("text_overtime_type_name_in_khmer")}
            />
            <SelectInput
              name="type"
              label={t("text_type")}
              placeholder={t("text_select_type")}
              errorMessage={t("text_please_select_type")}
              valueKey="id"
              required={true}
              isAutoSelect={true}
              dataSource={[
                { id: 1, name: t("text_holiday") },
                { id: 2, name: t("text_normal") },
                { id: 3, name: t("text_night_shift") },
                { id: 4, name: t("text_day_off") },
                { id: 5, name: t("text_compensation") },
              ]}
            />
            <NumberInput
              name="rate"
              label={t("text_rate")}
              required={true}
              placeholder={t("text_how_much_rate_ot_you_provide_hour")}
              isAutoSelect={true}
              errorMessage={t("text_please_input_rate")}
              min={0}
            />
            <Form.Item
              label={t("text_time")}
              className="overtime-type"
              required={true}
            >
              <div className="time">
                <TimeInput
                  name="startTime"
                  required={true}
                  errorMessage={t("text_please_select_start_time")}
                  format={timeFormat}
                  placeholder={t("text_start_time")}
                  className="start-time"
                  use12Hours={true}
                  style={styles.startTime}
                />
                <TimeInput
                  name="endTime"
                  format={timeFormat}
                  className="end-time"
                  required={true}
                  errorMessage={t("text_please_select_end_time")}
                  use12Hours={true}
                  placeholder={t("text_end_time")}
                  style={styles.endTime}
                />
              </div>
            </Form.Item>

            <div className="ant-modal-footer2">
              <Button
                className="btn-cancel"
                onClick={this.handleCancel}
                disabled={disabled}
              >
                {t("text_cancel")}
              </Button>
              <Button
                className="btn-save"
                type="primary"
                htmlType="submit"
                loading={loading}
              >
                {t("text_save")}
              </Button>
            </div>
          </Form>
        </Spin>
      </Modal>
    ) : (
      <div />
    );
  }
}
const styles = {
  startTime: {
    margin: "0px -20px",
  },
  endTime: {
    margin: "0px 14px",
  },
};
